import Vue from "vue";

Vue.directive('close-mobile-search', {

    bind(el) {
        el.onclick = function(event) {

            event.preventDefault();

            if($(document).outerWidth() < 992) {
                $('.search-mobile__input').blur();
                $('.search-mobile__result-wrapper').slideUp(300);
                $('.mobile-navigation__close-search').fadeOut(150);
                setTimeout(function () {
                    $('.mobile-navigation__close').fadeIn(150);
                }, 300);
            }
        };
    },
});
